import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, Output } from '@angular/core';
import { MessageInboxItem, MeyMessageInboxClient } from '../../../web-api-client';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-message-box',
  templateUrl: './message-box.component.html',
  styleUrls: ['./message-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageBoxComponent implements OnInit {

  @Output() onMessageSelect: Subject<MessageInboxItem> = new Subject();

  public messageCount: number = 0;
  public recentMessages: MessageInboxItem[] = [];
  public isLoading: boolean = false;

  constructor(
    public cdr: ChangeDetectorRef,
    private meyMessageClient: MeyMessageInboxClient,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadRecentMessages();
  }

  /**
   * Public method to refresh messages - can be called by parent component
   */
  public refresh(): void {
    this.loadRecentMessages();
  }

  private loadRecentMessages(): void {
    this.isLoading = true;
    this.cdr.detectChanges();

    this.meyMessageClient.getRecentUnread().subscribe({
      next: (result) => {
        // Messages are already sorted and limited by the server
        this.recentMessages = result.messages || [];
        this.messageCount = result.totalUnreadCount || 0;
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Error loading recent messages:', error);
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    });
  }

  formatDate(date: Date | string | null | undefined): string {
    if (!date) return '';

    const dateObj = new Date(date);
    const day = dateObj.getDate().toString().padStart(2, '0');
    const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
    const year = dateObj.getFullYear();

    return `${day}.${month}.${year} г.`;
  }

  onSelect(event: MessageInboxItem) {
    this.onMessageSelect.next(event);
  }

  navigateToInbox(): void {
    this.router.navigate(['/mail/inbox']);
  }
}
